module.exports = __webpack_public_path__ + "img/flag_es.cc1b41b0.svg";